module.exports = __webpack_public_path__ + "img/logo-icon-white.f68f7909.png";